import { ListSubheader, MenuItem, TextField } from "@mui/material";
import { Ico_Secure } from "@sagecentral/core-ui";
import { IAttachmentFormPayload, IAttachmentTypeListItem, IAttachmentValidator } from "models/attachments";
import React, { ChangeEvent, ReactElement } from "react";

type AttachmentTypeListProps = {
    disabled?: boolean;
    types: IAttachmentTypeListItem[] | null;
    value: number;
    onChanged: (value: number) => void;
};

const AttachmentTypeList: React.FC<AttachmentTypeListProps> = (props) => {
    const {
        disabled,
        types,
        value,
        onChanged
    } = props;

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const attType = parseInt((event.target as HTMLInputElement).value);
        onChanged(attType);
    };

    const buildSelectListComponents = () => {        
        let result = new Array<ReactElement>();
        if (types && types.length > 0) {
            types.forEach((type) => {
                if (type.isGroupHeader) {
                    result.push(<ListSubheader>{type.name}</ListSubheader>);
                }
                else {
                    result.push(
                        <MenuItem key={type.id} value={type.id}>
                            {type.isSensitive 
                                ? <strong><svg fill="none" height={24} width={24}><Ico_Secure/></svg>{type.name}</strong>
                                : type.name
                            }
                        </MenuItem>);
                }
            });
        }
        return result;
    }

    return (
        <TextField
            id="attachment-type"
            defaultValue=""
            select
            fullWidth
            onChange={handleChange}
            label={types && types.length > 0 ? "Attachment Type (required):" : "Loading."}
            value={value}
            disabled={types && types.length > 0 ? disabled : true}
            SelectProps={{
                multiple: false
            }}
        >
            {buildSelectListComponents()}
        </TextField>
    )
};

export default AttachmentTypeList;